angular.module("Main").controller("AggregatorStep4Controller", ["$rootScope", "$scope", "$state", "$localStorage", "$uibModal", "$window", "$stateParams", "$location", "$translate", "DialogService", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $localStorage, $uibModal, $window, $stateParams, $location, $translate, DialogService, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            vm.mandantNr = $stateParams.club;
            loadAggregatorenConfig();
        } else {
            vm.withoutClubsMenuItem = false;
            vm.cookies = SessionService.checkSession();
            if (!_.isNil(vm.cookies.aggregatorClubData)) {
                vm.clubData = vm.cookies.aggregatorClubData;
                vm.aggregatorData = vm.cookies.aggregatorData;
                vm.mandantNr = vm.clubData.selectedMandantNr;
                vm.mandatBezeichnung = vm.clubData.selectedMandantName;
                loadAggregatorenConfig();
            }
        }

        function loadAggregatorenConfig() {
            vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
            BookingService.loadVerifizierungText(vm.mandant, vm.aggregatorData).then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }

        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.errorRegisterDialog = false;

        vm.errorNotFound = false;
        vm.errorFound = false;
        vm.globalError = false;
        vm.errorTan = false;

        let abschliessen = false;
        vm.spinner = false;
        vm.showFormular = true;

        if (!SessionService.getSessionId()) {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        } else
            start();

        function start() {
            vm.cookies = SessionService.checkSession();
            init();
        }

        loadConfigs();
        getKursbuchungLayouKonfiguration();
        loadOnlineSalesFarbenConfiguration();
        loadRegisterRequired();

        function loadRegisterRequired() {
            BookingService.loadRegisterReq().then(function (data) {
                vm.registrationRequiredFields = data;
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $('#register-focus').autofocus;


        function init() {
            if (_.isNil(vm.cookies.aggregatorData) || _.isNil(vm.cookies.aggregatorData)) {
                if (!_.isEmpty($stateParams.club)) {
                    $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                } else {
                    $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                }
            }
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
            });
        }

        function loadOnlineSalesFarbenConfiguration() {
            BookingService.getOnlineSalesLayout().then(function (data) {
                vm.layoutColors = angular.fromJson(data.Layout_Colors);
            })
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.goToAngebot = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        vm.pairingError = false;
        vm.setTanStep = function (valid) {
            {
                if (valid) {
                    vm.errorTan = false;
                    vm.errorNotFound = false;
                    vm.errorFound = false;
                    vm.globalError  = false;
                    vm.spinner = true;
                    vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
                    return BookingService.createPairing(vm.cookies.aggregatorMemberData.Member, vm.cookies.aggregatorData.Name, vm.code, vm.mandant).then(function (data) {
                        vm.createdPairing = true;
                        vm.pairingError = false;
                        vm.spinner = false;
                        vm.setTan = false;
                        vm.errorNotFound = false;
                        vm.errorFound = false;
                        vm.globalError = false;
                        vm.errorTan = false;
                        $state.go('aggregator_success', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club})
                    }).catch(function (error) {
                        vm.pairingError = true;
                        vm.errorText = error.data;
                        if (error.status === 400) {
                            vm.errorTan = true;
                        }
                        if (error.status === 404) {
                            vm.errorNotFound = true
                        }
                        if (error.status === 409) {
                            vm.errorFound = true;
                        }
                        else {
                            vm.globalError = true;
                        }
                        vm.createdPairing = false;
                        vm.spinner = false;
                        vm.setTan = false;
                    })
                }
            }
        }

        vm.goBack = function () {
            $state.go('aggregator_register', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

    }]);